exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-drop {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, .5);\n}\n.back-drop .vue-modal {\n  position: relative;\n  width: 600px;\n  height: 300px;\n  z-index: 9999;\n  margin: 0 auto;\n  padding: 20px 30px;\n  background-color: #fff;\n}\n.back-drop .close{\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.back-drop .center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);

// exports
